module.exports = __webpack_public_path__ + "static/media/tancda.83b592bc.png";